import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

// Os filtros das abas ficam presos no alto do corpo do Dialog enquanto a lista rola
export const FilterContainer = styled(Container)`
  position: sticky;
  top: 0px;
  background-color: var(--background);
  width: 100%;
  padding: 0px;
  z-index: 5;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  flex-direction: row;
  align-items: flex-start;
`

export const Info = styled(Container)`
  padding: 0px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  padding-top: 10px;
  margin-bottom: 10px;
  border-radius: 15px;
  justify-content: center;
  align-items: flex-start;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  width: 720px;
  background-color: transparent;
  border-radius: 15px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const LinkText = styled.a`
  color: #44CF6C;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  text-decoration: none;
  font-weight: 500;
  gap: 5px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
